import { CropperPosition } from 'ngx-image-cropper';

export class CropperPositionImpl implements CropperPosition {
    public x1: number;
    public y1: number;
    public x2: number;
    public y2: number;
  }
